import React, { useEffect, useState } from 'react';
import { client } from '../../client';
import { useParams, useNavigate } from 'react-router-dom';
import { TbEdit } from 'react-icons/tb';
import filler from '../../assets/filler.png';
import { useAlert } from 'react-alert';
import Spinner from '../Spinner'; 
import { fetchUser } from '../../utils/FetchUser';

const ProfileImages = ({ user, userId }) => {
    const [loading, setLoading] = useState(false);
    const [wrongImageType, setWrongImageType] = useState(false);
    const [imageAsset, setImageAsset] = useState();
    const [profImageAsset, setProfImageAsset] = useState();
    const [isBanUploaded, setIsBanUploaded] = useState(false);
    const [isProfUploaded, setIsProfUploaded] = useState(false);
    const navigate = useNavigate();
    const alert = useAlert();
    const User = fetchUser();

    const uploadImage = (e) => {
        setImageAsset(null);
        const selectedFile = e.target.files[0];
        if (selectedFile.type === 'image/png' || selectedFile.type === 'image/svg' || selectedFile.type === 'image/jpeg' || selectedFile.type === 'image/gif' || selectedFile.type === 'image/tiff') {
            setWrongImageType(false);
            setLoading(true);
            client.assets
                .upload('image', selectedFile, { contentType: selectedFile.type, filename: selectedFile.name })
                .then((document) => {
                    setImageAsset(document);
                    setLoading(false);
                    setIsBanUploaded(true);
                })
                .catch((error) => {
                    console.log('Upload of ban failed:', error.message);
                    alert.show(
                        <div style={{ color: 'white' }}>
                            Upload Failed
                        </div>);
                });
        } else {
            setLoading(false);
            setWrongImageType(true);
            alert.show(
                <div style={{ color: 'white' }}>
                    Upload Failed. Wrong Image Type.
                </div>);
        }
    };

    const uploadProfImage = (e) => {
        setProfImageAsset(null);
        const selectedFile = e.target.files[0];
        if (selectedFile.type === 'image/png' || selectedFile.type === 'image/svg' || selectedFile.type === 'image/jpeg' || selectedFile.type === 'image/gif' || selectedFile.type === 'image/tiff') {
            setWrongImageType(false);
            setLoading(true);
            client.assets
                .upload('image', selectedFile, { contentType: selectedFile.type, filename: selectedFile.name })
                .then((document) => {
                    setProfImageAsset(document);
                    setLoading(false);
                    setIsProfUploaded(true);
                    // saveProf();
                })
                .catch((error) => {
                    console.log('Upload of prof failed:', error.message);
                    alert.show(
                        <div style={{ color: 'white' }}>
                            Upload Failed
                        </div>);
                    setProfImageAsset(null);
                });
        } else {
            setLoading(false);
            setWrongImageType(true);
            alert.show(
                <div style={{ color: 'white' }}>
                    Upload Failed. Wrong image type.
                </div>);
            setImageAsset(null);
        }
    };

    const saveBan = () => {
        if (imageAsset !== null) {
            client
                .patch(user?._id)
                .set({
                    bannerImage: imageAsset?.url,
                })
                .commit()
                .then((doc) => {
                    console.log('Hurray, Banner is updated! New document:');
                    console.log(doc);
                    setIsBanUploaded(false);
                })
                .catch((err) => {
                    console.error('Oh no, the update failed: ', err.message);
                    setImageAsset(null);
                    alert.show(
                        <div style={{ color: 'white' }}>
                            Upload Failed. Wrong image type.
                        </div>);
                })
        } else {
            setIsBanUploaded(false);
            console.log("no image detected")
        }
    };

    const saveProf = () => {
        if (profImageAsset !== null) {
            console.log("Save prof");
            client
                .patch(user?._id)
                .set({
                    profImage: profImageAsset?.url,
                })
                .commit()
                .then((doc) => {
                    console.log('Hurray, Profile is updated! New document:');
                    console.log(doc);
                    setIsProfUploaded(false);
                })
                .catch((err) => {
                    console.error('Oh no, the update failed: ', err.message);
                    setProfImageAsset(null);
                    alert.show(
                        <div style={{ color: 'white' }}>
                            Upload Failed. Wrong image type.
                        </div>);
                })
        } else {
            setIsProfUploaded(false);
            console.log("no image detected")
        }
    };

    return (
        <div className="flex flex-col justify-center items-center">
            <div
                className=" cursor-zoom-in w-full hover:shadow-lg overflow-hidden transition-all duration-500 ease-in-out"
            >
                <div
                    className="absolute top-0 w-full h-fit flex flex-col justify-between p-1 pr-2 pt-2 pb-2"
                    style={{ height: '100%' }}
                >
                    {loading && (
                        <Spinner />
                    )}
                    {
                        wrongImageType && (
                            <p>Wrong file type.</p>
                        )
                    }
                </div>
                <img
                    className=" w-full h-100 2xl:h-51 shadow-lg object-cover"
                    src={imageAsset ? imageAsset.url : (user?.banUrl != undefined ? user.banUrl : filler)}
                    alt="user-pic"
                />
                {user?._id === User?.sub &&
                    <>
                        <label>
                            <div className="absolute bottom-16 z-20 right-0 p-1">
                                <div className='bg-indigo-500 text-black font-bold p-2 rounded-full w-auto m-1 outline-none'>
                                    <TbEdit />
                                </div>
                                <input
                                    type="file"
                                    name="upload-image"
                                    onChange={uploadImage}
                                    className="w-0 h-0"
                                />

                            </div>
                        </label>
                        {isBanUploaded &&
                            <div className="absolute bottom-15 z-20 right-0 p-1">

                                <button
                                    className='bg-indigo-500 text-white text-xs font-bold p-2 rounded-full w-auto m-1 outline-none'
                                    onClick={() => { saveBan() }}>
                                    save
                                </button>
                            </div>
                        }
                    </>
                }
                <div
                    className="absolute top-0 w-full h-fit flex flex-col justify-between p-1 pr-2 pt-2 pb-2 z-40"
                >

                </div>

            </div>


            <div className='flex'>
                <img
                    className="rounded-full w-20 h-20 -mt-10 shadow-xl object-cover"
                    src={profImageAsset?.url ? profImageAsset.url : user?.profUrl}
                    alt="user-pic"
                />
                {user?._id === User?.sub &&
                    <label className='flex z-0 right-0'>
                        <div className='bg-indigo-500 text-black font-bold p-2 rounded-full w-auto m-1 outline-none '>
                            <TbEdit />
                        </div>
                        <input
                            type="file"
                            name="upload-image"
                            onChange={uploadProfImage}
                            className="w-0 h-0"
                        />
                    </label>
                }
                {isProfUploaded &&
                    <div className="absolute bottom-15 z-20 right-0 p-1">
                        <button
                            className='bg-indigo-500 text-white text-xs font-bold p-2 rounded-full w-auto m-1 outline-none'
                            onClick={() => { console.log("saveProf"); saveProf() }}>
                            save
                        </button>
                    </div>
                }
            </div>
        </div>
    )
}

export default ProfileImages